<!-- overlay div is here to make the click outside on the color picker work.
	It doesn't work if the element behind is gojs canvas -->
<div class="color-picker-backdrop" *ngIf="colorPickerOpened"></div>
<div [matTooltip]="tooltip">
  <button
    mat-icon-button
    [colorPicker]="color || '#ffffff'"
    [cpPositionRelativeToArrow]="true"
    cpPositionOffset="50%"
    cpOutputFormat="hex"
    cpAlphaChannel="always"
    cpFallbackColor="#ffffff"
    [intercomTarget]="'toolbar-context-menu-color'"
    (colorPickerChange)="colorChanged.emit($event)"
    (cpToggleChange)="colorPickerOpened = $event"
  >
    <fa-icon
      [icon]="faIcon"
      [fixedWidth]="true"
      [ngClass]="{ inverse: inverse }"
      [ngStyle]="{
        color: color ? (color | contextMenuColor : inverse) : 'inherit',
        'background-color': color && addBackground ? (color | contextMenuColor : inverse : true) : 'inherit',
        'border-color': color && addBackground ? (color | contextMenuColor : inverse) : 'inherit',
        stroke: addBackground ? null : '#03053D',
        'stroke-width': addBackground ? null : '10'
      }"
    >
    </fa-icon>
  </button>
</div>
<fa-icon
  *ngIf="nullable"
  class="delete-color-button"
  matRipple
  matTooltip="Remove color"
  (click)="colorChanged.emit('#ffffff00')"
  [intercomTarget]="'toolbar-context-menu-color-remove'"
  [icon]="['fal', 'times']"
  size="xs"
></fa-icon>
